<template>
  <div id="carousel">
    <el-carousel height="500px">
      <el-carousel-item v-for="item in slideshows" :key="item.id">
        <img :src="item.path" height="100%" width="100%">
        <!-- <h3>{{ item }}</h3> -->
      </el-carousel-item>
    </el-carousel>
    <!-- <div id="nx-carousel" v-on:mouseover="closeTimer()" v-on:mouseout="startTimer()">
      <div class="nx-carousel-item" v-for="img in slideshows" :key="img.url" name="carousel">
        <a :href="img.href">
          <img v-bind:src="img.url" :alt="img.title" width="100%" height="100%">
        </a>
      </div>
      <div class="indicators">
        <ul>
          <li
            v-for="(img ,index) in slideshows"
            :class="[index==0 ? 'after':'']"
            :key="img.url"
            v-on:mouseover="switchCarousel($event,index)"
          ></li>
        </ul>
      </div>
    </div>-->
  </div>
</template>
<style scoped>
#carousel {
  width: 100%;
  height: 496px;
}

#nx-carousel {
  width: 100%;
  height: 496px;
  margin: 0 auto;
  background-color: #f2f2f2;
  position: relative;
}

.nx-carousel-item {
  width: 100%;
  height: 496px;
  position: absolute;
  opacity: 0;
  transition: all 0.5s;
}

.nx-carousel-item:first-child {
  opacity: 100;
}

.indicators {
  margin: 0 auto;
  height: 20px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 9999;
}

.indicators ul {
  width: 100%;
}

.indicators ul li {
  width: 18px;
  height: 16px;
  border-radius: 50%;
  background: url("../assets/slider-dot.png") no-repeat 0 -16px;
  float: left;
  margin: 3px;
  cursor: pointer;
}
.after {
  background: url("../assets/slider-dot.png") no-repeat 0 0px !important;
}
</style>

<script>
export default {
  name: "carousel",
  data() {
    return {
      /** 轮播图数组 */
      slideshows: [
        {
          title: "校园",
          url: require("../assets/2017122016334095.jpg"),
          href: "存放图片点击后的跳转"
        },
        {
          title: "校园",
          url: require("../assets/2017122713484850.jpg"),
          href: "sdf似懂非懂都是"
        },
        {
          title: "校园",
          url: require("../assets/2017122713492412.jpg"),
          href: "sdf是的范德萨第三方是"
        }
      ],
      /**存放定时器 */
      timer: null,
      num: 0
    };
  },
  methods: {
    /** 将切换轮播图的代码封装起来  滑动切换和定时切换都同时用到，降低代码的重复率 */

    /** 切换轮播图 */
    switchCarousel: function(e, index) {
      this.num = index;
      $(".indicators")
        .find("li")
        .removeClass("after");
      $(e.target).addClass("after");
      $(".nx-carousel-item").css("opacity", 0);
      $(".nx-carousel-item")
        .eq(index)
        .css("opacity", 100);
    },
    /** 关闭定时器 */
    closeTimer: function() {
      clearInterval(this.timer);
    },
    /** 开启定时器 */
    startTimer() {
      // var num = 0;
      /** 最大值 */
      var max = this.slideshows.length - 1;
      var self = this;
      this.timer = setInterval(function() {
        self.num++;
        if (self.num > max) {
          self.num = 0;
        }
        $(".indicators")
          .find("li")
          .removeClass("after");

        $(".indicators")
          .find("li")
          .eq(self.num)
          .addClass("after");

        $(".nx-carousel-item").css("opacity", 0);

        $(".nx-carousel-item")
          .eq(self.num)
          .css("opacity", 1000);

        /** num大于slidesshows就==0 重新开始计算  */
      }, 3000);
    }
  },
  /** 生命周期函数（载入后）进行定时轮播 */
  mounted: function() {
    var self = this;
    this.ajax("/carousels.php", "get", null, function(data) {
      self.slideshows = JSON.parse(data);
    });
    // this.startTimer();
  },
  /** 生命周期函数，销毁后需要关闭这个定期器，不关闭会导致一值存在 */
  destroyed: function() {
    // clearInterval(this.timer);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/carousel.vue